import { useGetLabTaskStatusQuery } from "@/services/dashboard";

const useLabTaskStatus = () => {
  const { data, error, isLoading } = useGetLabTaskStatusQuery();

  return {
    labTasks: data?.data?.items || [],
    isLoading,
    error,
  };
};

export default useLabTaskStatus;
